import React from 'react'

const Logo = () => {
  return (
    <span className="logo">OA</span>
  )
}

export default Logo